import React from "react";
import { useParams, Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { ArrowLeft, Download, Share2 } from "lucide-react";
import { mockBusinessCard } from "../mock";

const CardPreview = () => {
  const { id } = useParams();
  
  // In a real app, this would fetch the card data by ID
  const cardData = mockBusinessCard;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-gray-100">
      {/* Navigation */}
      <nav className="bg-white/80 backdrop-blur-md border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/create">
              <Button variant="ghost" size="sm" className="text-gray-600 hover:text-gray-900">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back to Creator
              </Button>
            </Link>
            <h1 className="text-xl font-bold text-gray-900">Card Preview</h1>
            <div className="flex space-x-2">
              <Button variant="outline" size="sm">
                <Share2 className="h-4 w-4 mr-2" />
                Share
              </Button>
              <Button size="sm">
                <Download className="h-4 w-4 mr-2" />
                Download
              </Button>
            </div>
          </div>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <Card>
          <CardHeader>
            <CardTitle>Business Card Preview</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-center">
              <p className="text-gray-600 mb-8">
                Preview functionality will be implemented with the backend integration
              </p>
              <div className="bg-gray-100 p-12 rounded-lg">
                <p className="text-2xl font-bold text-gray-900 mb-2">{cardData.companyName}</p>
                <p className="text-lg text-gray-700">{cardData.personalName}</p>
                <p className="text-gray-600">{cardData.email}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default CardPreview;